module.exports = __webpack_public_path__ + "img/img_element_two.17424d37.svg";